module.exports = __webpack_public_path__ + "static/media/non_ulip.72220bc9.mp3";